var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0C0.537 0 0 0.537 0 1.2V9.6H1.2V1.2H9.6V0H1.2ZM3.6 2.4C2.937 2.4 2.4 2.937 2.4 3.6V10.8C2.4 11.463 2.937 12 3.6 12H10.8C11.463 12 12 11.463 12 10.8V3.6C12 2.937 11.463 2.4 10.8 2.4H3.6ZM3.6 3.6H10.8V10.8H3.6V3.6Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8c2150cfa6a205de9f8b070606970eb4.svg";
export { ForwardRef as ReactComponent };